import type { SupabaseClient } from '@supabase/supabase-js';

/**
 * Die Vario-Adresse des Mandanten, aus der Antwort von
 * `kaufland_get_vario_public_base_url` ausgewaehlt.
 *
 * ACHTUNG, hier lag am 2026-08-16 ein Fehler: Die RPC ist als
 * `returns table (public_base_url text, derived_base_url text)` deklariert und liefert
 * deshalb ein ARRAY VON ZEILEN, keinen Text. Ein `typeof data === 'string'` ist immer
 * falsch, faellt still auf den abgeleiteten Host zurueck und sieht im Bundle trotzdem so
 * aus, als sei der Fix drin -- der Funktionsname steht ja da.
 *
 * `public_base_url` ist die Domain, unter der der Haendler seine Installation aufruft
 * (erfasst aus dem Referrer, Migration 0031). `derived_base_url` rechnet die Datenbank aus
 * dem Realm des Offline-Tokens aus und liefert damit `https://tn0000001529.vario.cloud` --
 * einen technischen Host, auf dem die Sitzung des Haendlers nicht laeuft. Er bleibt als
 * Rueckfall, solange die oeffentliche Domain nicht erfasst ist: ein wackliger Link ist
 * besser als gar keiner.
 */
export function waehleVarioBasisUrl(
  data: Array<{ public_base_url?: string | null; derived_base_url?: string | null }> | null,
): string | null {
  if (!Array.isArray(data)) return null;
  const zeile = data[0];
  if (!zeile) return null;
  const oeffentlich = zeile.public_base_url;
  if (typeof oeffentlich === 'string' && oeffentlich.length > 0) return oeffentlich;
  const abgeleitet = zeile.derived_base_url;
  return typeof abgeleitet === 'string' && abgeleitet.length > 0 ? abgeleitet : null;
}

/** Laedt die Vario-Basis-Adresse. Fail-soft: null, wenn die RPC nichts liefert. */
export async function ladeVarioBasisUrl(supabase: SupabaseClient): Promise<string | null> {
  const { data, error } = await supabase.rpc('kaufland_get_vario_public_base_url');
  if (error) {
    console.warn('[vario-base-url] RPC fehlgeschlagen', error.message);
    return null;
  }
  return waehleVarioBasisUrl(data as Parameters<typeof waehleVarioBasisUrl>[0]);
}
